<template>
    <v-card class="card-home">
        <v-card-text>
            <v-row>
                <v-col class="col-card-img">
                    <img class="img-home" :src="route_img" :alt="route_alt">
                </v-col>
            </v-row>
            <v-row>
                <v-col class="col-card-title">
                    <span class="title-home">{{ route_name }}</span>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: "HomeCard",
    props: {
        route_name: String,
        route_img: String,
        route_alt: String
    },
}

</script>

<style scoped lang="scss">
@import "@/styles/components/home-card.scss";
</style>

